/**
 * @author 阿佑[ayooooo@petalmail.com]
 * @date 2022/4/22 18:49
 * @description
 *   indexedDB.ts of WeTrade
 */

export const open = async (name: string, version = 1): Promise<IDBDatabase> => {
  if (!window.indexedDB) return Promise.reject('No indexedDB support!!')

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(name, version)
    request.onsuccess = () => resolve(request.result)
    request.onerror = e => reject(e)
  })
}

export const readAll = <T = any>(db: IDBDatabase, table: string): Promise<T[]> => {
  return new Promise((resolve, reject) => {
    if (!db.objectStoreNames.contains(table)) {
      return reject(`No objectStore '${table}' found in db '${db.name}'`)
    }

    const transaction = db.transaction(table)

    transaction.onerror = e => reject(e)

    const objectStore = transaction.objectStore(table)

    const request = objectStore.getAll()
    request.onsuccess = () => resolve(request.result as T[])
    request.onerror = e => reject(e)
  })
}
